<template>
	<div class="eli-head-with-shadow" :class="classAddons">
		<img alt="" class="eli-head-with-shadow__image" :src="eliAvatarUrl" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ELI_AVATAR_INSIGHTS } from '@/features/Eli/constants';

const {
	isAnimated = false,
	eliAvatarUrl = ELI_AVATAR_INSIGHTS,
	width = '24px',
} = defineProps<{
	isAnimated?: boolean;
	eliAvatarUrl?: string;
	width?: string;
}>();

const classAddons = computed(() => {
	return {
		'eli-head-with-shadow--animated': isAnimated,
	};
});
</script>

<style lang="scss">
.eli-head-with-shadow {
	position: relative;
	width: v-bind(width);
	aspect-ratio: 1;

	&__image {
		display: block;
		position: relative;
		width: 100%;
		height: 100%;
		transition: transform 0.2s ease;
	}

	@include eli-shadow;

	&--animated {
		&:hover {
			.eli-head-with-shadow__image {
				transform: translateY(-4px);
			}

			&::before {
				transform: scale(1.1);
			}
		}
	}
}
</style>
